export default ({icon, text}) => {
  return <div className="ks-empty">
    {icon ? <div className="icon">{icon}</div> : null}
    <div className="text">{text || '暂无数据'}</div>
  </div>;
}